import { render } from "./NotFound.vue?vue&type=template&id=21b3d1e2&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=21b3d1e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b3d1e2"]])

export default __exports__